import {createColumnHelper} from '@tanstack/react-table';
import {
  DeleteButtonWithConfirmation,
  EditButton,
  ShowButton,
} from 'components/refinedev/action_buttons';
import {defaultQueryOptions} from 'pages/_utils';
import {BaseKey, BaseRecord} from '@refinedev/core';
import StateBoundary from '@/components/basic/StateBoundary';
import formatter from '@/lib/formatter';
import {DataTable} from '@/components/data-table/data-table';
import {DataTableColumnHeader} from '@/components/data-table/data-table-column-header';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';
import {CreateProjectContractDialogButton} from './components/project-contract-create-dialog-button';
import {ProjectContractEditDialogButton} from './components/project-contract-edit-dialog-button';

const thisResource = 'project_contracts';

const columnHelper = createColumnHelper<any>();

const ProjectContractList = ({project}: {project?: BaseRecord}) => {
  const columns = [
    columnHelper.accessor('id', {
      id: 'id',
      meta: {label: 'ID'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => info.getValue(),
    }),
    columnHelper.accessor('project.name', {
      id: 'project',
      meta: {label: 'Dự án'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => info.renderValue(),
    }),
    columnHelper.accessor('contract_number', {
      id: 'contract_number',
      meta: {label: 'Số hợp đồng'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => info.renderValue(),
    }),
    columnHelper.accessor('name', {
      id: 'name',
      meta: {label: 'Tên hợp đồng'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => {
        return info.renderValue();
      },
    }),
    columnHelper.accessor('description', {
      id: 'description',
      meta: {label: 'Mô tả'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => {
        return info.renderValue();
      },
    }),
    columnHelper.accessor('value', {
      id: 'value',
      meta: {label: 'Giá trị'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => {
        return info.renderValue();
      },
    }),
    columnHelper.accessor('start_date', {
      id: 'start_date',
      meta: {label: 'Ngày bắt đầu'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => {
        return formatter.formatDate(info.getValue());
      },
    }),
    columnHelper.accessor('end_date', {
      id: 'end_date',
      meta: {label: 'Ngày kết thúc'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => {
        return formatter.formatDate(info.getValue());
      },
    }),
    columnHelper.accessor('status', {
      id: 'status',
      meta: {label: 'Trạng thái'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: info => {
        return info.renderValue();
      },
    }),
    columnHelper.display({
      id: 'actions',
      meta: {label: 'Hành động'},
      header: ({column}) => <DataTableColumnHeader column={column} />,
      cell: ({row, table}) => (
        <div className="flex flex-row">
          {/* <ShowButton id={String(info.row.getValue('id'))} resource={thisResource} /> */}
          <ProjectContractEditDialogButton
            id={String(row.original.id)}
            canParams={{
              my_project_role: row.original.my_project_role,
            }}
            onSuccess={() => refineTable.tableQuery.refetch()}
          />
          <DeleteButtonWithConfirmation
            id={String(row.original.id)}
            resource={thisResource}
            canParams={{
              my_project_role: row.original.my_project_role,
            }}
            onSuccess={() => refineTable.tableQuery.refetch()}
          />
        </div>
      ),
    }),
  ];

  const _columns = project?.id ? columns.filter(c => c.id !== 'project') : columns;
  const {refineTable, tanstackTable} = useRefineTanstackDataTable(
    {
      resource: project?.id ? `projects/${project?.id}/contracts` : thisResource,
      sorters: {initial: [{field: 'id', order: 'asc'}]},
      // filters: project_id
      //   ? {permanent: [{field: 'project_id', operator: 'eq', value: project_id}]}
      //   : undefined,
      queryOptions: {
        ...defaultQueryOptions,
      },
      errorNotification: false,
      meta: {with: []},
    },
    {columns: _columns},
  );

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={thisResource}
              table={tanstackTable}
              createButton={
                project?.id ? (
                  <CreateProjectContractDialogButton
                    onSuccess={() => refineTable.tableQuery.refetch()}
                    project_id={project.id}
                    canParams={{my_project_role: project.my_role}}
                  />
                ) : (
                  false
                )
              }
              // filters={
              //   <DataTableFilters defaultValues={{name: ''}} table={tanstackTable}>
              //     <TextInput source="name" label='Tên'/>
              //   </DataTableFilters>
              // }
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

// ProjectContractList.table_columns = columns;

export default ProjectContractList;
